import React from 'react'
import {createRoot} from 'react-dom/client'
import App from './App.jsx'
import DescadastraPage from './pages/Descadastra.jsx'
import './styles/lp.css'
import './services/tracking.ts';
import {iniciarRastreioCta} from './utils/cta-tracker.ts'
import {TRACKING_ENABLED, VENDA_SUSPENSA} from '@/config/env'
import {apiFetch} from './services/apiBase.js'
import {tokenDePagina} from './services/paginaToken.js'
import {aplicarPrecos} from './utils/precos.js'

const trackingState = TRACKING_ENABLED ? 'enabled' : 'disabled'
if (typeof document !== 'undefined') {
    document.documentElement?.setAttribute('data-tracking', trackingState)
    document
        .querySelectorAll('[data-show-when-tracking]')
        .forEach((node) => {
            const el = node
            const desired = (el.getAttribute('data-show-when-tracking') || 'true').toLowerCase()
            const showWhenTracking = !(desired === 'false' || desired === '0')
            const shouldShow = TRACKING_ENABLED ? showWhenTracking : !showWhenTracking
            if (el instanceof HTMLElement) {
                el.hidden = !shouldShow
            } else if (!shouldShow) {
                el.setAttribute('aria-hidden', 'true')
            } else {
                el.removeAttribute('aria-hidden')
            }
        })
}

// 🧠 Mostra variáveis só em dev
if (import.meta.env.DEV) {
    console.table({
        MODE: import.meta.env.MODE,
        API_BASE: import.meta.env.VITE_API_BASE_URL || '(proxy local ativo)',
        GOOGLE_META_TRACKING: TRACKING_ENABLED ? 'enabled' : 'disabled',
        PAGINA: import.meta.env.VITE_PAGINA,
        DEFAULT_USUARIO_BOT_ID: import.meta.env.VITE_DEFAULT_USUARIO_BOT_ID || import.meta.env.VITE_DEFAULT_BOT_ID
    })
}

iniciarRastreioCta()

// Preços da vitrine vêm da API a cada visita: o prazo dos grupos cai a cada assembleia.
// Usa o token da página (em memória), o mesmo do chat. A rota de preços é do escopo PAGINA_VENDA: com PAGINA_CHAT
// o servidor devolve 403 e ficam os valores do HTML.
// Se a API falhar, ficam os valores escritos no HTML.
if (!VENDA_SUSPENSA) tokenDePagina.obter()
    .then((token) => apiFetch('/api/siens/venda-fluxo/creditos', {headers: {Authorization: `Bearer ${token}`}}))
    .then((r) => (r.ok ? r.json() : []))
    .then((planos) => aplicarPrecos(document, planos))
    .catch(() => {})

// Renderiza a página correspondente. Este bloco foi apagado sem querer no #11 (preços): sem ele
// o chat e o aviso de venda suspensa nunca montam.
const rootElement = document.getElementById('root')
const currentPath = (window.location.pathname || '/').replace(/\/+$/, '') || '/'
createRoot(rootElement).render(currentPath === '/descadastra' ? <DescadastraPage/> : <App/>)
